module.exports = __webpack_public_path__ + "static/media/intelog_new_png.a1abac1a.png";